/**
 * ч.831 (правило власника): у підписах довідників внутрішній код — НЕ на
 * початку, а в кінці («Назва — CODE»); договір — назва + № номер (якщо є) +
 * від дата (якщо є), без внутрішнього коду.
 */
export function withCode(name: string | null | undefined, code: string | null | undefined): string {
  const n = (name ?? '').trim();
  const c = (code ?? '').trim();
  if (!n) return c;
  return c ? `${n} — ${c}` : n;
}

function fmtDate(d: string): string {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(d);
  return m ? `${m[3]}.${m[2]}.${m[1]}` : d;
}

export function contractLabel(c: {
  name?: string | null; number?: string | null; contract_date?: string | null; code?: string | null;
}): string {
  const name = (c.name ?? '').trim() || (c.code ?? '') || 'Договір';
  const num = (c.number ?? '').trim();
  const date = (c.contract_date ?? '').trim();
  return `${name}${num ? ` № ${num}` : ''}${date ? ` від ${fmtDate(date)}` : ''}`;
}
